import { AgeGroup, EligibleRegisterGroup } from '@schooly/api';

import {
  isSessionScope,
  REGISTER_PERIOD_TAB,
  REGISTER_SESSIONS,
  RegisterScope,
  RegisterSession,
  RegisterTab,
} from '../types';

const getGroupSession = (group: EligibleRegisterGroup, session: RegisterSession) =>
  group.sessions.find((entry) => entry.session === session);

const getGroupSlot = (group: EligibleRegisterGroup, periodId: string) =>
  group.slots.find((slot) => slot.period_id === periodId);

type GroupAvailability = { scheduled: boolean; explicitly_removed: boolean };

export const getGroupAvailability = (
  group: EligibleRegisterGroup,
  scope: RegisterScope,
): GroupAvailability | undefined =>
  isSessionScope(scope)
    ? getGroupSession(group, scope.session)
    : getGroupSlot(group, scope.periodId);

export const groupEligibleForSession = (
  group: EligibleRegisterGroup,
  session: RegisterSession,
): boolean => !!getGroupSession(group, session);

export const groupEligibleForPeriod = (group: EligibleRegisterGroup, periodId: string) =>
  !!getGroupSlot(group, periodId);

export const getAvailableSessions = (eligibleGroups: EligibleRegisterGroup[]): RegisterSession[] =>
  REGISTER_SESSIONS.filter((session) =>
    eligibleGroups.some((group) => groupEligibleForSession(group, session)),
  );

const hasEligiblePerPeriodGroups = (groups: EligibleRegisterGroup[]) =>
  groups.some((group) => group.slots.length > 0);

const hasSchoolPerPeriodSetting = (ageGroups: AgeGroup[]) =>
  ageGroups.some((ageGroup) => ageGroup.attendance_frequency?.per_period_enabled);

export const getAvailableRegisterTabs = (
  eligibleGroups: EligibleRegisterGroup[],
  ageGroups: AgeGroup[],
): RegisterTab[] => {
  const sessions = getAvailableSessions(eligibleGroups);
  const perPeriodAvailable =
    hasEligiblePerPeriodGroups(eligibleGroups) || hasSchoolPerPeriodSetting(ageGroups);

  return [...sessions, ...(perPeriodAvailable ? [REGISTER_PERIOD_TAB] : [])];
};
